import React from "react";
import { ArrowDownRight, ArrowRight, ArrowUpRight, Boxes } from "lucide-react";

import { variacao } from "../lib/historico";
import { numero, reais } from "../lib/numeros";
import { emDuasMedidas, quantidade, sigla } from "../lib/unidades";

// Tradução do que foi digitado: quanto entra no estoque e se o preço está acima da média.
export default function ResumoLancamento({ l, media }) {
  if (!l.ing || !(l.qtd > 0)) return null;
  const unit = l.ing.unit;
  const precoEstoque = l.total > 0 ? l.total / l.qtd : null;
  const { principal, secundaria } = emDuasMedidas(l.ing, l.qtd);
  const v = variacao(precoEstoque, media);
  const cor = v == null || Math.abs(v) < 1 ? "text-muted-foreground" : v > 0 ? "text-amber-600 dark:text-amber-400" : "text-emerald-600 dark:text-emerald-400";
  const Seta = v == null || Math.abs(v) < 1 ? ArrowRight : v > 0 ? ArrowUpRight : ArrowDownRight;

  return (
    <div className="rounded-xl border bg-muted/30 p-3 space-y-2 text-sm" data-e2e="resumo-lancamento">
      <div className="flex items-start gap-2">
        <Boxes className="w-4 h-4 mt-0.5 text-sky-600 dark:text-sky-400 shrink-0" />
        <p>
          <b>{principal}</b>{secundaria ? <> = <b>{secundaria}</b></> : null} entram no estoque
          {precoEstoque != null && <> · <b>{reais(precoEstoque)}</b> por {sigla(unit)}</>}
          {secundaria ? null : <span className="text-muted-foreground"> ({quantidade(l.qtd, unit)})</span>}
        </p>
      </div>
      {v != null && (
        <div className={`flex items-start gap-2 ${cor}`} data-e2e="comparacao-media">
          <Seta className="w-4 h-4 mt-0.5 shrink-0" />
          <p>
            {Math.abs(v) < 1 ? "No preço da média" : `${numero(Math.abs(v), 1)}% ${v > 0 ? "mais caro" : "mais barato"} que a média`}
            {" "}das últimas compras ({reais(media)} por {sigla(unit)})
          </p>
        </div>
      )}
    </div>
  );
}
